import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-22",
  "use": "icon-22-usage",
  "viewBox": "0 0 8.64 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.64 18\" id=\"icon-22\"><defs><style> </style></defs><g transform=\"translate(-152 -76)\"><path class=\"a\" d=\"M154.88,91.12V94H152V91.12Zm5.76,0V94h-2.88V91.12Zm-5.76-5.04v2.88H152V86.08Zm5.76,0v2.88h-2.88V86.08Zm-5.76-5.04v2.88H152V81.04Zm5.76,0v2.88h-2.88V81.04ZM154.88,76v2.88H152V76Zm5.76,0v2.88h-2.88V76Zm0,0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol